import { useNavigate } from 'react-router-dom';
import { usuario } from '../data/mock';

export default function Login() {
  const navigate = useNavigate();
  return (
    <div className="login-page">
      <div className="login-logo-circle">🏠</div>
      <div className="login-title">NTTasar</div>
      <div className="login-sub">Tasaciones para corredores</div>
      <div className="login-form">
        <div className="login-field">
          <span className="login-field-icon">✉️</span>
          <span className="login-field-text">{usuario.email}</span>
        </div>
        <div className="login-field">
          <span className="login-field-icon">🔒</span>
          <span className="login-field-text">••••••••</span>
        </div>
        <button className="login-btn" onClick={() => navigate('/dashboard')}>
          Ingresar
        </button>
        <div className="login-bio">
          <span className="login-bio-icon">👆</span>
          <span className="login-bio-text">Acceso biométrico</span>
        </div>
        <div style={{ textAlign: 'center' }}>
          <div className="license-pill">
            ✅ Licencia activa — vence {usuario.licencia.vencimiento}
          </div>
        </div>
      </div>
    </div>
  );
}
